import { UnicoViewProps } from "./types";
import { useEffect } from "react";

export const UnicoView = ({ url }: UnicoViewProps) => {
  useEffect(() => {
    window.location.href = url;
  }, []);

  return null;
};
